import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';

import { COWTUXDemoContentComponent } from './demo-content/demo-content.component';
import { COWTUXDemoSidebarComponent } from './demo-sidebar/demo-sidebar.component';

@NgModule({
    declarations: [
        COWTUXDemoContentComponent,
        COWTUXDemoSidebarComponent
    ],
    imports     : [
        RouterModule,

        MatDividerModule,
        MatListModule
    ],
    exports     : [
        COWTUXDemoContentComponent,
        COWTUXDemoSidebarComponent
    ]
})
export class COWTUXDemoModule
{
}
